<template>
  <section class="hp-section hp-jobs hp-animate">
    <div class="container">
      <div class="hp-section__head">
        <div>
          <h2 class="hp-section__title">Latest openings</h2>
          <p class="hp-section__subtitle">Fresh roles from top companies across India</p>
        </div>
        <a href="/jobs" class="hp-btn hp-btn--outline hp-hide-mobile">View all jobs</a>
      </div>

      <div v-if="mobileCategories.length" class="hp-filter-pills hp-show-mobile">
        <a
          v-for="cat in mobileCategories"
          :key="cat.href"
          :href="cat.href"
          class="hp-filter-pill"
          target="_blank"
          rel="noopener"
        >{{ cat.mobileLabel || cat.label }}</a>
      </div>

      <div v-if="!loading && jobs.length" class="hp-jobs__grid">
        <JobCardCompact
          v-for="job in jobs"
          :key="job.job_id"
          :job="job"
        />
      </div>

      <div v-if="!loading && jobs.length" class="hp-jobs__footer">
        <a href="/jobs" class="hp-btn hp-btn--primary hp-btn--lg">View all jobs <span aria-hidden="true">→</span></a>
      </div>

      <div v-if="!loading && !jobs.length" class="hp-empty">
        <p>No jobs to show right now.</p>
        <a href="/jobs" class="hp-btn hp-btn--primary">Browse all jobs</a>
      </div>

      <div v-if="loading" class="hp-jobs__grid">
        <div class="hp-job-card hp-job-card--skeleton" v-for="n in 6" :key="n">
          <content-loader viewBox="0 0 300 140" primaryColor="#f1f5f9" secondaryColor="#e2e8f0">
            <rect x="0" y="0" rx="8" ry="8" width="40" height="40" />
            <rect x="0" y="56" rx="4" ry="4" width="200" height="14" />
            <rect x="0" y="78" rx="4" ry="4" width="120" height="10" />
            <rect x="0" y="100" rx="4" ry="4" width="160" height="10" />
            <rect x="0" y="126" rx="4" ry="4" width="80" height="10" />
          </content-loader>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import JobCardCompact from '@/components/JobCardCompact.vue';
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'HomeJobList',
  components: { JobCardCompact, ContentLoader },
  props: {
    jobs: { type: Array, default: () => [] },
    loading: { type: Boolean, default: true },
    categories: { type: Array, default: () => [] },
  },
  computed: {
    mobileCategories() {
      return this.categories.filter(cat => cat.showOnMobile !== false);
    },
  },
};
</script>
